export const PROTECTED_WORKSPACE_COMPONENT_NAMES = ["NeuralCanvas"] as const;

type CloseComponent = {
  id: string;
  name: string;
  dependencyIds?: string[];
  dockGroup?: { peerId: string };
};

/** Calculate close effects without changing the captured workspace or its tokens. */
export function planWorkspaceClose<T extends CloseComponent>(
  components: readonly T[],
  targetIds: readonly string[],
  closedAt: Date,
  options: { allowProtectedRemoval?: boolean } = {},
): { remaining: T[]; closed: (T & { deletedDate: Date })[] } {
  if (!Number.isFinite(closedAt.getTime())) throw new Error("Invalid workspace close time");
  const protectedComponent = (component: T) => !options.allowProtectedRemoval
    && PROTECTED_WORKSPACE_COMPONENT_NAMES.some(name => name === component.name);
  const requested = new Set(targetIds);
  const direct = components.filter(component => requested.has(component.id) && !protectedComponent(component));
  const removedIds = new Set(direct.flatMap(component => [component.id, ...(component.dependencyIds ?? [])]));
  const closed = components.filter(component => removedIds.has(component.id) && !protectedComponent(component))
    .map(component => ({ ...component, deletedDate: closedAt }));
  const closedIds = new Set(closed.map(component => component.id));
  const remaining = components.filter(component => !closedIds.has(component.id)).map(component => {
    if (!component.dockGroup || !closedIds.has(component.dockGroup.peerId)) return component;
    const { dockGroup, ...undocked } = component;
    void dockGroup;
    return undocked as T;
  });
  return { remaining, closed };
}
